<template>
  <div>
    <page-header title="系统管理" description="管理公开舆情的数据源、平台策略、任务、接口和运行日志"/>
    <el-tabs v-model="tab">
      <el-tab-pane label="基础配置" name="basic">
        <el-card><basic-settings :value="basic" @save="saveBasic"/></el-card>
      </el-tab-pane>
      <el-tab-pane label="数据源" name="source">
        <el-card><data-source-settings :value="tikhub" @save-key="saveKey"/></el-card>
      </el-tab-pane>
      <el-tab-pane label="作品监测账号" name="creator-account">
        <el-card><creator-account-settings/></el-card>
      </el-tab-pane>
      <el-tab-pane label="公开舆情平台" name="policy">
        <el-card>
          <platform-policy
            :value="policies"
            :readiness="readiness"
            :endpoints="endpoints"
            :verifying="verifyingPlatform"
            @save="savePolicy"
            @verify="verifyPlatform"
          />
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="接口配置" name="endpoint">
        <el-card><endpoint-manager @changed="refreshEndpoints"/></el-card>
      </el-tab-pane>
      <el-tab-pane label="任务中心" name="task">
        <el-card>
          <el-descriptions v-if="run" :column="2" border>
            <el-descriptions-item label="任务编号">{{ run.id }}</el-descriptions-item>
            <el-descriptions-item label="状态">{{ run.status }}</el-descriptions-item>
            <el-descriptions-item label="阶段">{{ run.stage }}</el-descriptions-item>
          </el-descriptions>
          <el-empty v-else description="尚无采集任务"/>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="日志中心" name="log">
        <el-card>
          <el-table :data="logs">
            <el-table-column prop="created_at" label="时间"/>
            <el-table-column prop="log_type" label="类型"/>
            <el-table-column prop="action" label="动作"/>
            <el-table-column prop="summary" label="说明"/>
          </el-table>
        </el-card>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { yuqingApi } from '@/api/yuqing'
import PageHeader from '../components/PageHeader.vue'
import BasicSettings from './BasicSettings.vue'
import DataSourceSettings from './DataSourceSettings.vue'
import PlatformPolicy from './PlatformPolicy.vue'
import EndpointManager from './EndpointManager.vue'
import CreatorAccountSettings from './CreatorAccountSettings.vue'

export default {
  components: { PageHeader, BasicSettings, DataSourceSettings, PlatformPolicy, EndpointManager, CreatorAccountSettings },
  data () {
    return {
      tab: this.$route.query.tab === 'creator-account' ? 'creator-account' : 'basic',
      basic: {},
      tikhub: {},
      policies: [],
      readiness: [],
      endpoints: [],
      logs: [],
      run: null,
      verifyingPlatform: ''
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    async load () {
      try {
        const [basic, tikhub, policies, readiness, endpoints, logs, run] = await Promise.all([
          yuqingApi.get('system/basic-settings'),
          yuqingApi.get('settings/tikhub'),
          yuqingApi.get('system/platform-policies'),
          yuqingApi.get('platform-readiness'),
          yuqingApi.get('endpoints'),
          yuqingApi.get('system/logs?limit=200'),
          yuqingApi.get('runs/latest')
        ])
        this.basic = basic
        this.tikhub = tikhub
        this.policies = policies.policies || []
        this.readiness = readiness.readiness || []
        this.endpoints = endpoints.endpoints || []
        this.logs = logs.logs || []
        this.run = run.run
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    async refreshReadiness () {
      const result = await yuqingApi.get('platform-readiness')
      this.readiness = result.readiness || []
    },
    async refreshLogs () {
      try {
        this.logs = (await yuqingApi.get('system/logs?limit=200')).logs || []
      } catch (error) {
        this.$message.error(error.message || '操作日志刷新失败')
      }
    },
    async refreshEndpoints () {
      try {
        this.endpoints = (await yuqingApi.get('endpoints')).endpoints || []
        await this.refreshLogs()
      } catch (error) {
        this.$message.error(error.message || '接口状态刷新失败')
      }
    },
    async verifyPlatform (platform) {
      if (this.verifyingPlatform) return
      this.verifyingPlatform = platform.platform
      try {
        await yuqingApi.post(`platforms/${encodeURIComponent(platform.platform)}/smoke`, {})
        await this.refreshReadiness()
        const readiness = this.readiness.find(item => item.platform === platform.platform)
        if (readiness && readiness.search_ready) {
          this.$message.success(`${platform.display_name}验证通过，现在可以开启自动舆情`)
          return
        }
        const errors = ((readiness && readiness.checks) || [])
          .filter(check => !check.passed && check.error_summary)
          .map(check => check.error_summary)
        const detail = Array.from(new Set(errors)).join('；')
        this.$message.error(detail || `${platform.display_name}验证未通过，请检查数据源配置`)
      } catch (error) {
        this.$message.error(error.message)
      } finally {
        this.verifyingPlatform = ''
      }
    },
    async saveBasic (value) {
      try {
        this.basic = await yuqingApi.put('system/basic-settings', value)
        this.$message.success('基础配置已保存')
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    async savePolicy (value) {
      try {
        await yuqingApi.put('system/platform-policies', value)
        this.$message.success('平台策略已保存')
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    async saveKey (key) {
      if (!key) return this.$message.warning('请输入 TikHub API Key')
      try {
        await yuqingApi.put('settings/tikhub', { api_key: key })
        this.$message.success('数据源配置已保存')
        this.load()
      } catch (error) {
        this.$message.error(error.message)
      }
    }
  }
}
</script>
